import { z } from "zod";

export const billingTaskSchemaFactory = () => {
    const schema = z.object({
        amount: z.coerce.string()
            .refine(amountAsString => {
                // First check if we have been given the correct amount of decimal points
                const fraction = amountAsString.split(".")[1];
                if (!fraction || fraction.length !== 2) {
                    return false;
                }

                const amountAsNumber = Number(amountAsString);

                // Then convert to a number and check it's within the allowed range
                if (!amountAsNumber || amountAsNumber < 5 || amountAsNumber > 5000)
                {
                    return false;
                }

                return true;
            }, { message: "Value must be between 5.00 and 5000.00, including decimal points" }),
        taskCode: z.string({ required_error: "Please make a selection", invalid_type_error: "Please make a selection" }),
        notes: z.string().optional()
    });

    return schema;
};
